import { useEffect, useState } from 'react';

import { LoginForm } from './style';
import { LoginApi,PermissionApi,UserApi } from "gmrfid-service-user-api-client"
import { Button, Form, Input, Row, message } from 'antd';
import store from '@/store';
import { useHistory } from 'troyfe';
import { arrayToTree } from '../../utils/index';
import { imgUrlHandle } from '@/utils';
import defaultSettings from '@/defaultSettings';

const Login = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  // const [appState] = store.useModel('app');
  const [appState, appDispatchers] = store.useModel('app');
  const { appConfig } = appState;
  const [loginLoading, setLoginLoading] = useState(false);
  const [time, setTime] = useState();

  useEffect(() => {
    LoginApi.getDomain({}).then((res: any) => {
      if (res.data) {
        sessionStorage.setItem('httpUrl', res.data);
      }
    });
  }, []);

  useEffect(() => {
    console.log('process.env.NODE_ENV', process.env.NODE_ENV);
    LoginApi.logo({
      key: process.env.NODE_ENV === 'development' ? 'wjmhadmin-dev.jmhvip.com' : window.location.host,
    }).then((res) => {
      localStorage.setItem('appConfig', JSON.stringify((res as any)?.data || '{}'));
      if (res?.data) {
        console.log('data', res.data);
        appDispatchers.updateStates({
          payload: {
            ...res.data,
          },
        });
        document.title = res?.data?.appConfig?.title || '';
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = imgUrlHandle(res.data?.appConfig?.icon?.logo2) || imgUrlHandle('logo/40_40.png'); // icon图标
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    });
  }, []);

  /* 获取文件路径 */
  const queryFileUrl = (_res: any) => {
    sessionStorage.setItem(
      'userInfo',
      JSON.stringify({
        token: _res.data,
      }),
    );
  };

  /* [获取用户信息、获取当前用户按钮权限、获取当前用户的权限] */
  const storageFn = () => {
    try {
      Promise.all([
        UserApi.getUserInfo({}),
        PermissionApi.button({}),
        PermissionApi.menu({}),
      ]).then((res: any) => {
        if (res) {
          sessionStorage.setItem('user', JSON.stringify({ ...res[0].data }));
          sessionStorage.setItem('button', JSON.stringify(res[1].data));
          if (res[2].data.length > 0) {
            const res2Data = res[2].data.map((item) => {
              const obj = item;
              if (item.name.includes('-')) {
                obj.name = item.name.split('-')[0];
              }
              return obj;
            });
            const res2 = arrayToTree(res2Data, 'id', 'parentId');
            const arr = [];
            res2.map((item) => {
              // if (!item.parentId && item.type !== 'APPLICATION') {
              if (!item.parentId) {
                arr.push(item);
              }
            });

            let obj = {};
            arr.forEach((it, index) => {
              if (it.uri === '/' || it.uri === '/HYIndustryWorkbench' || it.uri === '/mallHome' || it.uri === '/combo') {
                obj = it;
                arr.splice(index, 1);
              }
            });
            if (obj?.uri) {
              arr.unshift(obj);
            }
            sessionStorage.setItem('menu', JSON.stringify(arr));
            const indexObj = arr.find(
              (it) => it.uri === '/' || it.uri === '/HYIndustryWorkbench' || it.uri === '/mallHome' || it.uri === '/combo',
            );

            /* 如果有菜单且有子菜单，就子一, 有无首页 */
            if (indexObj) {
              sessionStorage.setItem(
                'nav',
                JSON.stringify([
                  {
                    ...indexObj,
                    close: false,
                  },
                ]),
              );
              history.push(indexObj.uri);
            } else if (res2.length > 1 && res2[0].children) {
              history.push(res2[0]?.children[0].uri);
              sessionStorage.setItem(
                'nav',
                JSON.stringify([
                  {
                    ...res2[0]?.children[0],
                  },
                ]),
              );
            } else if (res2.length > 0) {
              history.push(res2 && res2[0].uri);
              sessionStorage.setItem(
                'nav',
                JSON.stringify([
                  {
                    ...res2[0],
                  },
                ]),
              );
            } else {
              message.warning('你没有相关权限,联系管理员。');
            }
            // dispatch({
            //   type: 'app/updateStates',
            //   payload: {
            //     isRefresh: Math.random(),
            //   },
            // });
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onFinish = () => {
    // setLoginLoading(true);
    form
      .validateFields()
      .then((values) => {
        LoginApi.phonePasswordLoginAdmin({
          form: { ...values, platform: 'ADMIN_MANAGER' },
        })
          .then((_res: any) => {
            queryFileUrl(_res);
            storageFn(_res);
          })
          .catch((err) => { })
          .finally((info) => {
            setTimeout(() => {
              setLoginLoading(false);
            }, 2000);
          });
      })
      .catch((info) => {
        setTimeout(() => {
          setLoginLoading(false);
        }, 2000);
        console.log('info', info);
      });
  };
  return (
    <LoginForm>
      <div className="login_content">
        <img src={imgUrlHandle(appConfig.icon?.logo1)} alt="" />
        <Form form={form} className="form" onFinish={onFinish}>
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: '请输入手机号',
                pattern: new RegExp(/^[1-9]\d{10}$/),
              },
            ]}
          >
            <Input size="large" placeholder="请输入手机号" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: '请输入登录密码',
              },
            ]}
          >
            <Input.Password size="large" type="password" placeholder="请输入密码" style={{ width: '100%' }} />
          </Form.Item>
          <Row>
            <Button
              style={{ background: '#44BB55', color: '#FFFFFF' }}
              size="large"
              className="submit"
              htmlType="submit"
              loading={loginLoading}
            >
              登 录
            </Button>
          </Row>
        </Form>
        <div className="tip">如忘记密码，请联系管理员</div>
      </div>
 
        </LoginForm>
  );
};

export default Login;
